import React, { useEffect, useState } from 'react';
import { ICON_EDIT, ICON_NEW, ICON_REMOVE, ICON_SEARCH, ICON_SHARE } from '../../../extras/icons';
import Swal from 'sweetalert2';
import { C_BLUE } from '../../../extras/colors';
import { Alert, Button } from 'react-bootstrap';
import { AGENDADA } from '../../../../data/audienceStates';
import ActuationForm from './forms/ActuationForm';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { listActsAction, addActsAction, deleteActsAction, editActsAction, migrateActsAction } from '../../../../actions/actsActions';
import clienteAxios from '../../../../config/axios';

import { ConfirmDeleteMessage, ErrorMessage, WaitingMessage } from '../../../extras/toastMessages';
import { MSG_ERROR_SERVER, MSG_GENERATING_PREVIEW, MSG_NOT_REVERT_OPERATION } from '../../../../constants/messages';
import ActuationPreview from './ActuationPreview';
import AuthoritiesService from '../../../../services/AuthoritiesService';
import { SOLICITUDES_MODIFICAR } from '../../../../data/objects';
//Función principal
const ActuationActions = props => {
    //Tomo los props
    const { audience } = props;
    //Inicializo los params
    const params = {
        search: `audiencia.id:${audience.id}`
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Accedo al store
    const acts = useSelector(state => state.acts.acts);
    const authorities = useSelector(state => state.auth.authorities);
    //Inicializo el state local
    const [ show, setShow ] = useState(false);
    const [ showPreview, setShowPreview ] = useState(false);
    const [ selectedAct, setSelectedAct ] = useState(null);
    const [ selectedText, setSelectedText ] = useState(null);
    //Cargo al inicio las actas generadas
    useEffect(() => {
        if(audience){
            //Cargo las actas
            dispatch( listActsAction(params) );
        }
    }, [audience]);
    //Función para ver texto
    const handleNew = () => {
        //Muestro dialógo
        setShow(true);
    }
    //Manejo el cierre
    const handleClose = () => {
        setShow(false);
    }
    //Creación
    const handleCreate = () => {
        //Llamo al dispatch
        dispatch( addActsAction(handleNew) );
    }
    //Manejo el borrado
    const handleRemove = act => {
        //Verifico el estado
        if(act.estado === 0){
            //Realizo confirmación
            ConfirmDeleteMessage(
                'Eliminar ACTA #' + act.id,
                MSG_NOT_REVERT_OPERATION,
                () => {
                    dispatch( deleteActsAction(act) )
                }
            );
        }
    }
    //Manejo la edición
    const handleEdit = act => {
        //Llamo al dispatch
        dispatch( editActsAction(act, handleNew) );
    }
    //Función que maneja la migración del acta
    const handleMigrateActuation = act => {
        //Realizo confirmación
        Swal.fire({
            title: 'Migrar datos de ACTA al SAE?',
            text: 'Una vez migrada, no se podrá editar la misma.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: C_BLUE,
            confirmButtonText: 'Si, Migrar'
        }).then((result) => {
            if(result.value){
                //Ejecuto
                dispatch( migrateActsAction(act) );
            }
        })
    }
    //Función para vista previa
    const handlePreview = async act => {
        try{
            //Espera
            WaitingMessage(MSG_GENERATING_PREVIEW);
            //Consulta
            const responsePreview = await clienteAxios.get(`/acta/generar/${act.id}`);
            //La data es el texto
            setSelectedAct(act);
            setSelectedText(responsePreview.data);
            //Oculto espera
            Swal.close();

            setTimeout(() => {
                //Muestro vista previsa
                setShowPreview(true);
            }, 300);
            
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Oculto la espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
    //Función para cerrar la vista
    const handleClosePreview = () => {
        setShowPreview(false);

        setTimeout(() => {
            setSelectedAct(null);
            setSelectedText(null);
        }, 300);
    }
    //Renderizo
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-2 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">ACTAS (Borradores)</h6>
                    <div className="dropdown no-arrow">
                    {
                        audience.estado.id === AGENDADA ? (
                            authorities && AuthoritiesService.hasPermission(authorities, SOLICITUDES_MODIFICAR) ? (
                                <Button variant="light" size="sm" className="float-right text-gray-400" onClick={handleCreate}>
                                    <ICON_NEW />
                                </Button>
                            ) : null
                        ) : null
                    }
                    </div>
                </div>
                {
                    acts ? (
                        acts.length > 0 ? (
                            <table className="table table-hover table-sm">
                                <thead className="thead-light">
                                    <th className="text-center">Descripción</th>
                                    <th className="text-center">Acciones</th>
                                </thead>
                                <tbody>
                                    {
                                        acts.filter(a => a.estado === 0).map(act => (
                                            <tr key={`aaid${act.id}`}>
                                                <td className="align-middle text-center">
                                                    ACTA DE AUDIENCIA #{ act.id }
                                                </td>
                                                <td className="align-middle text-center">
                                                    {
                                                        false ? (
                                                        <React.Fragment>
                                                            <Button variant="light" size="sm" onClick={() => handlePreview(act)}>
                                                                <ICON_SEARCH />
                                                            </Button>

                                                            <ActuationPreview
                                                                show={showPreview}
                                                                handleClose={handleClosePreview}
                                                                act={selectedAct}
                                                                text={selectedText}
                                                            />
                                                        </React.Fragment>        
                                                        ) : null
                                                    }
                                                    
                                                    {
                                                        authorities && AuthoritiesService.hasPermission(authorities, SOLICITUDES_MODIFICAR) ? (
                                                            <React.Fragment>
                                                                <Button variant="primary" size="sm" onClick={() => handleMigrateActuation(act)} className="ml-2">
                                                                    <ICON_SHARE />
                                                                </Button>
                                                                <Button variant="info" size="sm" onClick={() => handleEdit(act)} className="ml-2">
                                                                    <ICON_EDIT />
                                                                </Button>
                                                                <Button variant="danger" size="sm" onClick={() => handleRemove(act)} className="ml-2">
                                                                    <ICON_REMOVE />
                                                                </Button>
                                                            </React.Fragment>
                                                        ) : null
                                                    }
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        ) : (
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12">
                                        <Alert variant="info">
                                            Por el momento no hay actas generadas desde el sistema.
                                        </Alert>
                                    </div>
                                </div>
                            </div>
                        )
                    ) : null
                }
            </div>

            <ActuationForm
                show={show}
                handleClose={handleClose}
                audience={audience}
            />
        </div>
    );
};

export default ActuationActions;